export default {
  "content": "<g clip-path=\"url(#icon_payment_method_filled_svg__a)\"><path d=\"M16 8.28v4.8c0 .66-.54 1.2-1.2 1.2H1.2c-.66 0-1.2-.54-1.2-1.2v-4.8h5.24c.31 1.18 1.47 2 2.76 2 1.29 0 2.45-.82 2.76-2H16z\"/><path d=\"M16.01 7.28V5.29h-16v1.99H5.8c.35 0 .62.28.62.62 0 .7.65 1.38 1.59 1.38.94 0 1.59-.67 1.59-1.38 0-.35.28-.62.62-.62h5.79zM14.81 2c.66 0 1.2.54 1.2 1.2v1.07h-16V3.2c0-.66.54-1.2 1.2-1.2h13.6z\"/></g><defs><clipPath id=\"icon_payment_method_filled_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};